export default "__VITE_ASSET__830a11c2__"